import { BodyText } from '@unmind/design-system-components-web';
import { FontSizes } from '@unmind/design-system-theme';
import { styled } from 'styles';

export const EditTriggerButtonText = styled(BodyText).attrs({
  sizes: [FontSizes.fontSize14],
})``;
